import { Viewer } from "../Viewer";

window.WBApp = window.WBApp || {};
window.WBApp.utils = window.WBApp.utils || {};

window.WBApp.utils.Viewer = Viewer;

import {detectDoubleTap} from "../doubleTapEvent";
document.addEventListener('pointerup', detectDoubleTap(300));
